import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import './style.css';

class DebugMsg extends Component {

  constructor(props) {
    super(props);
    this.state = {
      status: null
    }
    this.scrollRef = createRef();
  }


  scrollToBottom = () => {
    this.scrollRef.scrollIntoView({ behavior: "auto" });
  }

  componentDidMount() {
    const { tabVisible } = this.props;
    tabVisible && this.scrollToBottom();
  }

  componentDidUpdate() {
    const { tabVisible } = this.props;
    tabVisible && this.scrollToBottom();
  }


  render() {
    const { uploadDebug, projectName, currentProjectId, uploadProjectId, msg, endMsg, debugMonitor, verificationName } = this.props;
    return (
      <Fragment>
        <div className='pdn-simulation-title'>
          <Row className='pdn-simulation-holygrail' span={24}>
            <Col className='pdn-simulation-msg'
              span={20}>
              {projectName && <div className='pdn-simulation-span pdn-simulation-project'>
                <span className='span-msg-project font-bold'>Project </span>
                <span className='span-msg'>{projectName}</span>
              </div>}
              {verificationName && <div className='pdn-simulation-span'>
                <span className='span-msg-project font-bold'>PDN </span>
                <span className='span-msg'>{verificationName} </span>
              </div>}
            </Col>
          </Row>
        </div>
        <div className='my-pdn-monitor'>
          <pre style={{ margin: 20, overflow: 'unset' }}>
            {uploadProjectId === currentProjectId && <>
              {msg}
              {uploadDebug && uploadDebug.length > 0 &&
                <ul className='pdn-monitor-ul' style={{ paddingLeft: 34, margin: 0 }}>
                  {uploadDebug.length && uploadDebug.map(item =>
                    <li key={item.id} style={{ listStyle: 'none', width: '100%' }}>
                      <p style={{ margin: 0 }}>{item.time}  {item.log}</p>
                    </li>)}
                </ul>}
              {endMsg}
            </> || null}
            {debugMonitor && debugMonitor.length > 0 && <ul className='pdn-monitor-ul' style={{ margin: 0 }}>
              {debugMonitor.length && debugMonitor.map((item, index) =>
                <li key={'debug_' + index} style={{ listStyle: 'none', width: '100%' }}>
                  <p style={{ margin: 0 }}>{item}</p>
                </li>)}
            </ul>}
          </pre>
          <div ref={(el) => { this.scrollRef = el; }}></div>
        </div>
      </Fragment>
    )
  }
}

const mapState = (state) => {
  const { TabMonitorReducer: { debugMonitor }, project: { currentProjectId } } = state.PDNReducer;
  const { debug, uploadProjectId, msg, endMsg } = state.PDNReducer.PDNUploadReducer;
  const { projectName, tabVisible, verificationName } = state.TabMonitorReducer;
  return {
    projectName,
    uploadProjectId,
    currentProjectId,
    uploadDebug: debug,
    tabVisible,
    msg,
    endMsg,
    debugMonitor,
    verificationName
  }
}

const mapDispatch = (dispatch) => ({
})

export default connect(mapState, mapDispatch)(DebugMsg);